export var Gray;
(function (Gray) {
    Gray["x100"] = "#000000";
    Gray["x200"] = "#D2D2D2";
    Gray["x300"] = "#F5F5F5";
    Gray["x400"] = "#EEEEEE";
})(Gray || (Gray = {}));
export var Pink;
(function (Pink) {
    Pink["x100"] = "#ff1744";
})(Pink || (Pink = {}));
export var Size;
(function (Size) {
    Size["body15"] = "15px";
})(Size || (Size = {}));
export var Shade;
(function (Shade) {
    Shade["x400"] = "4px 4px 12px rgb(0, 0, 0, 0.2)";
    Shade["x500"] = "0 0 35px rgba(0, 0, 0, 0.2)";
})(Shade || (Shade = {}));
//# sourceMappingURL=styles.js.map